import React from 'react'

const TermHeader = () => {
  return (
    <header id="header" className="ex-header">
  <div className="container">
    <div className="row">
      <div className="col-lg-12">
        <h1 className="white">Terms &amp; Conditions</h1>
      </div> {/* end of col */}
    </div> {/* end of row */}
  </div> {/* end of container */}
</header>

  )
}

export default TermHeader